import axios from '../requester';
import { API } from '../constants/api-urls';

export const createGroupTeam = async body => axios.post(API.GROUPS_PATH, body);

export const updateGroup = async body =>
  axios.patch(`${API.GROUPS_PATH}/${body.id}`, body);

export const deleteGroup = async id => axios.delete(`${API.GROUPS_PATH}/${id}`);
